import {Wizard} from '../models/wizard';
export class WizardService {

  wizardMap: Record<string, Wizard> = {};

  getWizard(wizardId: string): Wizard {
    if (this.wizardMap[wizardId] == null) {
      this.wizardMap[wizardId] = new Wizard(wizardId);
    }

    return this.wizardMap[wizardId];
  }
}
